export default "https://cdn-static.gokick.com/assets/0205635f2685a00e1fdcb9112c4ac213a84703ca/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";